import EditableField from '../EditableField';
import ImagePreview from '../../ImagePreview';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { BankAttachmentUpload } from '../BankAttachmentUpload';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Pencil, X } from 'lucide-react';

const UpiTab = ({ editData, updateField, canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit }) => {
  const editProps = { canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit };

  return (
    <div className="grid grid-cols-2 gap-4">
      <Card className="p-2 divide-y">
        <div className="px-3 py-2"><h3 className="font-semibold text-sm text-slate-700">UPI Details</h3></div>
        <EditableField field="upi" label="UPI ID" value={editData.upi} {...editProps} />
        <div className="flex items-center justify-between py-2 px-3 hover:bg-slate-50 group">
          <div className="flex-1">
            <span className="text-xs text-slate-500 block">QR Available</span>
            {editingField === 'qrAvailable' ? (
              <div className="flex items-center gap-2 mt-1">
                <Select value={editingValue || 'no'} onValueChange={(val) => { updateField('qrAvailable', val); cancelEdit(); }}>
                  <SelectTrigger className="h-8 w-32"><SelectValue /></SelectTrigger>
                  <SelectContent><SelectItem value="yes">Yes</SelectItem><SelectItem value="no">No</SelectItem></SelectContent>
                </Select>
                <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-500" onClick={cancelEdit}><X className="w-4 h-4" /></Button>
              </div>
            ) : (
              <span className="text-sm font-medium text-slate-800">{editData.qrAvailable === 'yes' ? 'Yes' : 'No'}</span>
            )}
          </div>
          {editingField !== 'qrAvailable' && canEdit && (
            <Button variant="ghost" size="sm" className="h-7 w-7 p-0 opacity-0 group-hover:opacity-100 transition-opacity" onClick={() => startEditing('qrAvailable', editData.qrAvailable)}>
              <Pencil className="w-3 h-3 text-blue-500" />
            </Button>
          )}
        </div>
        <div className="px-3 py-2">
          <span className="text-xs text-slate-500">Upload QR Image</span>
          <BankAttachmentUpload field="qr" className="mt-1" data-testid="upi-qr-upload" />
        </div>
      </Card>
      <Card className="p-4">
        <h3 className="font-semibold text-sm mb-2">QR Code</h3>
        <ImagePreview imageUrl={editData.qrDataUrl} label="QR Code" />
      </Card>
    </div>
  );
};

export default UpiTab;
